import type { ReactElement } from 'react'

const Navbar = (): ReactElement => {
  return (
    <nav className='font-display top-0 left-0 right-0 w-full h-16 py-8 bg-ut-secondary border-b-2 border-b-ut-primary'>
      <div className='container max-w-4xl h-full mx-auto px-6'>
        <div className='flex justify-center items-center md:justify-between h-full'>
          <div className='w-1/12 '>
            <img
              src='/logo.png'
              alt='UT Group Logo'
              className='logo max-w-[50px] h-auto'
            />
          </div>
          <div className='w-11/12 text-center'>
            <h1 className='text-xl text-gray-600 font-bold tracking-widest lg:text-2xl'>
              面談前アンケート
            </h1>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
